import useGoto from '~/hooks/use-goto';
import useOnLoad from '../use-on-load';

export default function Component({ r }: { r: string }) {
  const { goTo } = useGoto();
  useOnLoad(() => {
    if (r) {
      goTo(r);
    }
  });
  return null;
}
